export const ConsentLetterConfig = {
    BJ_EN: {
        path: "/ConsentLetter/BJ/ConsentLetter_en-US.jpeg",
        visitContentsImage: {width: 500, height: 500, fontSize: 20, lineSpace: 40, x: 600, y: 2420},
        signDateImage: {width: 500, height: 500, fontSize: 30, lineSpace: 40, x: 600, y: 2680}
    },
    BJ_ZH: {
        path: "/ConsentLetter/BJ/ConsentLetter_zh-CN.jpeg",
        visitContentsImage: {width: 500, height: 500, fontSize: 20, lineSpace: 40, x: 600, y: 2000},
        signDateImage: {width: 500, height: 500, fontSize: 30, lineSpace: 40, x: 600, y: 2280}
    },
    SH_EN: {
        path: "/ConsentLetter/SH/ConsentLetter_en-US.jpg",
        visitContentsImage: {width: 500, height: 700, fontSize: 16, lineSpace: 36, x: 500, y: 2180},
        signDateImage: {width: 500, height: 500, fontSize: 30, lineSpace: 40, x: 650, y: 2540}
    },
    SH_ZH: {
        path: "/ConsentLetter/SH/ConsentLetter_zh-CN.jpg",
        visitContentsImage: {width: 500, height: 700, fontSize: 22, lineSpace: 50, x: 600, y: 2046},
        signDateImage: {width: 500, height: 500, fontSize: 30, lineSpace: 40, x: 650, y: 2460}
    }
};